const install = (Vue)=>{
    const requireComponent = require.context('./Ebook',false,/\.vue/);
    requireComponent.keys().forEach(fileName=>{
        const config = requireComponent(fileName)
        // console.log(config);
        Vue.component(config.default.name,config.default)
    })
}
export default {
    install
}


// WEBPACK FOOTER //
// ./src/Epub/index.js